module.exports = (state, box) => {
  const boxId = box.boxid
  if (boxId !== undefined) {
    // Instead of an object, we could use a Map, so we make sure we only remove each box once.
    state.boxes[boxId] = undefined
    state.boxesCount = state.boxesCount - 1
  } else {
    throw new Error('Cannot delete box with id: undefined')
  }
}
